import { useEffect, useState } from 'react';

// One app-wide switch: 'amateur' (plain English) or 'pro' (betting shorthand).
const KEY = 'bet_view_mode';
const EVT = 'bet-view-mode';

export const getBetMode = () => localStorage.getItem(KEY) || 'amateur';
export const setBetMode = (m) => { localStorage.setItem(KEY, m); window.dispatchEvent(new Event(EVT)); };
export const ensureBetMode = (m) => { if (!localStorage.getItem(KEY)) setBetMode(m); };

export const useBetMode = () => {
  const [mode, setMode] = useState(getBetMode);
  useEffect(() => {
    const on = () => setMode(getBetMode());
    window.addEventListener(EVT, on);
    window.addEventListener('storage', on);
    return () => { window.removeEventListener(EVT, on); window.removeEventListener('storage', on); };
  }, []);
  return mode;
};

const DOES = {
  passing_yards: (m) => `throws for ${m} or more yards`,
  rushing_yards: (m) => `runs for ${m} or more yards`,
  receiving_yards: (m) => `gets ${m} or more receiving yards (yards after catching passes)`,
  passing_tds: (m) => (m > 1 ? `throws ${m} or more touchdown passes` : 'throws at least 1 touchdown pass'),
  anytime_td: () => 'scores a touchdown',
  points: (m) => `scores ${m} or more points`,
  rebounds: (m) => `grabs ${m} or more rebounds`,
  assists: (m) => `gets ${m} or more assists (passes that lead to a basket)`,
  threes: (m) => `makes ${m} or more 3-pointers`,
  pra: (m) => `gets ${m} or more points, rebounds and assists added together`,
  pr: (m) => `gets ${m} or more points and rebounds added together`,
  pa: (m) => `gets ${m} or more points and assists added together`,
  ra: (m) => `gets ${m} or more rebounds and assists added together`,
};
const ABBR = { passing_yards: 'pass yds', rushing_yards: 'rush yds', receiving_yards: 'rec yds', passing_tds: 'pass TD', anytime_td: 'ATD',
  points: 'pts', rebounds: 'reb', assists: 'ast', threes: '3PM', pra: 'PRA', pr: 'P+R', pa: 'P+A', ra: 'R+A' };

export const plainLeg = (x) => `${x.player} ${(DOES[x.stat] || ((m) => `gets ${m}+ ${x.label}`))(x.mark)}`;
export const proLeg = (x) => (x.stat === 'anytime_td' ? `${x.player} ATD` : `${x.player} o${x.mark - 0.5} ${ABBR[x.stat] || x.label}`);
export const proStats = (x) => {
  const st = x.stats || {};
  const n = (st.last5 || []).length;
  return [x.projection != null && `proj ${x.projection}`, st.season_avg != null && `szn ${st.season_avg}`, st.last5_avg != null && `L5 avg ${st.last5_avg}`,
    n > 0 && st.hits5 != null && `L${n} ${st.hits5}/${n}`].filter(Boolean).join(' · ');
};
export const legFor = (mode, x) => (mode === 'pro' ? proLeg(x) : plainLeg(x));
export const winFor = (mode, x) => (mode === 'pro' ? `${x.team} ML${x.ml ? ` ${x.ml > 0 ? '+' : ''}${x.ml}` : ''}` : `The ${x.team} win the game`);
